
import Vue from 'vue';
import Component from 'vue-class-component';
import { categoriesState } from '@/utils/store-acessor';
import { i18nModule } from '@/utils/store-acessor';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import { CategoryModel } from '@/models/category.model';
import SectionLayout from '@/components/SectionLayout.vue';
import { getCategories } from '@/models/category.model';
import { Watch } from 'vue-property-decorator';

@Component({
  components: { SectionLayout }
})
export default class HomeCategoriesMobile extends Vue {
  @i18nModule.Getter('locale') selected!: LocaleSelectorType;
  onuCategories!: any[];

  created() {
    if (this.selected.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
  }

  @Watch('selected')
  onLocaleSelected(v: LocaleSelectorType) {
    if (v.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
  }

  openCategory(slug: string, id: number) {
    if (id === 18) {
      window.open('https://sustainabledevelopment.un.org/?menu=1300', '_blank');
    } else {
      this.$router.push(`/categories/${slug}`);
    }
  }
}
